<app-core-offer-attribute-form></app-core-offer-attribute-form>
